export const GRAPH_URL = "https://graph.microsoft.com/v1.0";
export const AUTH_STORAGE_KEY = "@token";
